import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, withCtx as _withCtx, mergeProps as _mergeProps, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, normalizeClass as _normalizeClass, vShow as _vShow } from "vue"
import _imports_0 from '../assets/img/bobbee_hrz.png'
import _imports_1 from '../assets/img/bobbee_mini.png'


const _hoisted_1 = { class: "d-flex w-100 h-100" }
const _hoisted_2 = {
  style: {"width":"256px"},
  class: "align-self-center"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "expanded-group-content" }
const _hoisted_5 = { class: "expanded-group-content" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "mb-4 d-flex justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MobileNavigationDrawer = _resolveComponent("MobileNavigationDrawer")!
  const _component_MobileAppBar = _resolveComponent("MobileAppBar")!
  const _component_MobileBottomNavigation = _resolveComponent("MobileBottomNavigation")!
  const _component_ossAccountingFirmSelector = _resolveComponent("ossAccountingFirmSelector")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_oss_accounting_period_selector = _resolveComponent("oss-accounting-period-selector")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_AccountableAccountVue = _resolveComponent("AccountableAccountVue")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_SettingSCI = _resolveComponent("SettingSCI")!
  const _component_TutorialButtonDialog = _resolveComponent("TutorialButtonDialog")!
  const _component_profile_menu = _resolveComponent("profile-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_TreeView = _resolveComponent("TreeView")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_ThirdPartyCompanies = _resolveComponent("ThirdPartyCompanies")!
  const _component_UsersDialog = _resolveComponent("UsersDialog")!
  const _component_tag_manager = _resolveComponent("tag-manager")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_ChatList = _resolveComponent("ChatList")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_SnackbarSurvey = _resolveComponent("SnackbarSurvey")!
  const _component_v_responsive = _resolveComponent("v-responsive")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_v_responsive, null, {
    default: _withCtx(() => [
      (_ctx.$vuetify.display.mobile)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_MobileNavigationDrawer, {
              modelValue: _ctx.drawer,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.drawer) = $event)),
              currentUser: _ctx.currentUser,
              onPasswordChangeClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.passwordChange = true))
            }, null, 8, ["modelValue", "currentUser"]),
            _createVNode(_component_MobileAppBar, {
              selectedCompany: _ctx.selectedCompany.name,
              "onUpdate:selectedCompany": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCompany.name) = $event)),
              topButtonStyle: _ctx.topButtonStyle,
              onBack: _ctx.back,
              onCompanySelectClick: _cache[3] || (_cache[3] = ($event: any) => (
                    _ctx.dialogCompanySelection =
                        _ctx.currentUser.allAvailableCompanies.length === 1 ? null : true
                )),
              onUserBtnClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.drawer = !_ctx.drawer))
            }, null, 8, ["selectedCompany", "topButtonStyle", "onBack"]),
            (_ctx.currentUser && _ctx.currentUser.profile && !_ctx.toBeDoneStatus)
              ? (_openBlock(), _createBlock(_component_MobileBottomNavigation, {
                  key: 0,
                  modelValue: _ctx.currentMenu,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentMenu) = $event)),
                  currentUser: _ctx.currentUser,
                  userConfig: _ctx.userConfig
                }, null, 8, ["modelValue", "currentUser", "userConfig"]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_v_app_bar, {
              color: "background",
              elevation: "0",
              class: "overflow"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_ossAccountingFirmSelector)
                  ]),
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "bg-white rounded-bs-2xl w-100 px-2 flex-nowrap d-flex align-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "3",
                        class: "flex-grow-0 flex-shrink-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            placeholder: "Entreprise sélectionnée",
                            modelValue: _ctx.selectedCompany.name,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCompany.name) = $event)),
                            readonly: "",
                            "data-cy": "index-selectCompany",
                            variant: "outlined",
                            density: "comfortable",
                            style: _normalizeStyle(_ctx.topButtonStyle),
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (
                                    _ctx.isCompanySelectionDisabled
                                        ? null
                                        : (_ctx.dialogCompanySelection = true)
                                )),
                            outlined: "",
                            "append-inner-icon": _ctx.isAccountingUser ? '$oss-eye' : undefined,
                            "onClick:appendInner": _cache[8] || (_cache[8] = _withModifiers(($event: any) => (
                                    _ctx.$router.push({
                                        name: 'accountingClients',
                                        params: { mode: 'production' },
                                    })
                                ), ["stop"]))
                          }, null, 8, ["modelValue", "style", "append-inner-icon"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "3",
                        class: "flex-grow-0 flex-shrink-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_accounting_period_selector, {
                            companyId: _ctx.selectedCompany.id,
                            "hide-details": "",
                            placeholder: "Exercice Comptable",
                            variant: "outlined",
                            dense: "",
                            block: true,
                            style: _normalizeStyle(_ctx.topButtonStyle),
                            global: true,
                            withAccountingClosing: true,
                            disabled: _ctx.isAccountingPeriodSelectionDisabled
                          }, null, 8, ["companyId", "style", "disabled"])
                        ]),
                        _: 1
                      }),
                      (!_ctx.isAutonomousUser)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            class: "d-flex justify-center align-center flex-grow-0 flex-shrink-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                activator: _withCtx(({ props }) => [
                                  _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                    _createVNode(_component_AccountableAccountVue, {
                                      showLabel: true,
                                      showValidation: false,
                                      companyId: _ctx.selectedCompany.id,
                                      inAccountableAccountType: "Selected",
                                      embeddedInput: true,
                                      editAccountableAccount: true,
                                      defineThirdParty: true,
                                      displayCheckIcon: false
                                    }, {
                                      activator: _withCtx(({ props: propsAA }) => [
                                        _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$oss-accounting-plan" }, { ...propsAA, ...props }), null, 16)
                                      ]),
                                      _: 2
                                    }, 1032, ["companyId"])
                                  ], 16)
                                ]),
                                default: _withCtx(() => [
                                  _cache[31] || (_cache[31] = _createElementVNode("span", null, "Plan comptable", -1))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.isAutonomousUser && _ctx.currentUser)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 1,
                            class: "d-flex justify-center align-center flex-grow-0 flex-shrink-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn_icon, _mergeProps(props, {
                                    icon: "$oss-company",
                                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.activateEditThirdCompanies = true)),
                                    style: _ctx.topButtonStyle
                                  }), null, 16, ["style"])
                                ]),
                                default: _withCtx(() => [
                                  _cache[32] || (_cache[32] = _createElementVNode("span", null, "Tiers", -1))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.isAutonomousUser)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 2,
                            class: "d-flex justify-center align-center flex-grow-0 flex-shrink-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                activator: _withCtx(({ props }) => [
                                  (_ctx.currentUser)
                                    ? (_openBlock(), _createBlock(_component_v_btn_icon, _mergeProps({ key: 0 }, props, {
                                        icon: "$oss-user-card",
                                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.activateEditUsers = true)),
                                        style: _ctx.topButtonStyle
                                      }), null, 16, ["style"]))
                                    : _createCommentVNode("", true)
                                ]),
                                default: _withCtx(() => [
                                  _cache[33] || (_cache[33] = _createElementVNode("span", null, "Utilisateurs", -1))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_col, { class: "d-flex justify-center align-center flex-grow-0 flex-shrink-1" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_tooltip, { location: "bottom" }, {
                            activator: _withCtx(({ props }) => [
                              (_ctx.currentUser)
                                ? (_openBlock(), _createBlock(_component_v_btn_icon, _mergeProps({ key: 0 }, props, {
                                    icon: "$label_outline",
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.activateTagManager = true)),
                                    style: _ctx.topButtonStyle
                                  }), null, 16, ["style"]))
                                : _createCommentVNode("", true)
                            ]),
                            default: _withCtx(() => [
                              _cache[34] || (_cache[34] = _createElementVNode("span", null, "Étiquettes", -1))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_spacer, { class: "flex-grow-1 flex-shrink-0" }),
                      _createVNode(_component_v_col, { class: "d-flex justify-center align-center flex-grow-0 flex-shrink-1" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_tooltip, { location: "bottom" }, {
                            activator: _withCtx(({ props }) => [
                              _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                _createVNode(_component_Notification)
                              ], 16)
                            ]),
                            default: _withCtx(() => [
                              _cache[35] || (_cache[35] = _createElementVNode("span", null, "Notifications", -1))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.selectedCompany.legalForm === 'SCI')
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 3,
                            class: "d-flex justify-center align-center flex-grow-0 flex-shrink-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_SettingSCI, {
                                companyId: _ctx.selectedCompany.id
                              }, null, 8, ["companyId"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.$vuetify.display.mobile)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 4,
                            class: "flex-shrink-1 flex-grow-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_TutorialButtonDialog)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isHomeAvailable)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 5,
                            class: "flex-shrink-1 flex-grow-0"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_v_btn_icon, {
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.accoutantHome())),
                                icon: "$oss-outlined-home",
                                style: _normalizeStyle(_ctx.topButtonStyle),
                                "data-cy": "index-homepage"
                              }, null, 8, ["style"]), [
                                [
                                  _directive_tooltip,
                                  'Accueil',
                                  void 0,
                                  { bottom: true }
                                ]
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_col, { class: "flex-shrink-1 flex-grow-0" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_profile_menu)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            (_ctx.showNavigationDrawer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_ctx.mini)
                    ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                        key: 0,
                        color: "primary",
                        size: "x-small",
                        elevation: "0",
                        onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.mini = !_ctx.mini), ["stop"])),
                        style: _normalizeStyle(_ctx.styleMiniBtn),
                        class: "pl-3",
                        icon: "$fa-chevron-right",
                        variant: "flat",
                        rounded: "pill"
                      }, null, 8, ["style"]))
                    : (_openBlock(), _createBlock(_component_v_btn_icon, {
                        key: 1,
                        color: "secondary",
                        size: "x-small",
                        elevation: "0",
                        onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.mini = !_ctx.mini), ["stop"])),
                        style: _normalizeStyle(_ctx.styleMiniBtn),
                        class: "px-0",
                        icon: "$fa-chevron-left",
                        variant: "flat",
                        rounded: "pill"
                      }, null, 8, ["style"]))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_navigation_drawer, {
              app: "",
              clipped: "",
              flat: "",
              color: "primary",
              class: "rounded-te-xl border-0",
              rail: _ctx.mini,
              style: {"z-index":"99"}
            }, {
              append: _withCtx(() => [
                (!_ctx.mini)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      "no-gutters": "",
                      class: "mb-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "3",
                          class: "d-flex justify-end align-end text--primary px-1"
                        }, {
                          default: _withCtx(() => _cache[71] || (_cache[71] = [
                            _createTextVNode(" by ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "9",
                          class: "d-flex"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_img, {
                              src: _imports_0,
                              height: "30px"
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_v_img, {
                        src: _imports_1,
                        height: "30px"
                      })
                    ]))
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list, {
                  lines: "one",
                  nav: true,
                  true: "",
                  "base-color": "white",
                  density: "compact",
                  class: "space-y-1 text-lg"
                }, {
                  default: _withCtx(() => [
                    (_ctx.userConfig?.business?.dashboard)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 0,
                          to: { name: 'dashboard' }
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[36] || (_cache[36] = [
                                _createTextVNode("$oss-dashboard")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            (!_ctx.mini)
                              ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                  key: 0,
                                  class: "v-list-item-title-active"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("menu.dashboard")), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.showAccountingDashboardForClient && _ctx.isAllowedToDashboardAccounting)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 1,
                          to: { name: 'dashboardAccounting' }
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[37] || (_cache[37] = [
                                _createTextVNode("$fa-table")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            (!_ctx.mini)
                              ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                  key: 0,
                                  class: "v-list-item-title-active"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("menu.dashboardAccounting")), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.userConfig?.budget?.read && _ctx.isAllowedToBudget)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 2,
                          to: { name: 'budgets' }
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[38] || (_cache[38] = [
                                _createTextVNode("$oss-bar-chart")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            (!_ctx.mini)
                              ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                  key: 0,
                                  class: "v-list-item-title-active"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("menu.budgets")), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.showOutStandingCount > 1)
                      ? (_openBlock(), _createBlock(_component_v_list_group, {
                          key: 3,
                          value: "outstanding"
                        }, {
                          activator: _withCtx(({ props }) => [
                            (!_ctx.mini)
                              ? (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({
                                  key: 0,
                                  class: "v-list-item-title-active"
                                }, props, {
                                  "prepend-icon": "$fa-file-invoice",
                                  active: 
                                    _ctx.currentRouteName === 'outstandingTPC' ||
                                    _ctx.currentRouteName === 'outstandingUser'
                                
                                }), {
                                  default: _withCtx(() => [
                                    (!_ctx.mini)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                          key: 0,
                                          class: "v-list-item-title-active"
                                        }, {
                                          default: _withCtx(() => _cache[39] || (_cache[39] = [
                                            _createTextVNode(" Encours ")
                                          ])),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1040, ["active"]))
                              : _createCommentVNode("", true)
                          ]),
                          default: _withCtx(() => [
                            (_ctx.currentUser.showOutStandingClient && !_ctx.isAutonomousUser)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 0,
                                  to: { name: 'outstandingTPC', params: { mode: 'client' } },
                                  "prepend-icon": "$fa-file-invoice"
                                }, {
                                  default: _withCtx(() => [
                                    (!_ctx.mini)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                          key: 0,
                                          class: "v-list-item-title-active"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("menu.outstandingClient")), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.currentUser.showOutStandingSupplier && !_ctx.isAutonomousUser)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 1,
                                  to: { name: 'outstandingTPC', params: { mode: 'supplier' } },
                                  "prepend-icon": "$fa-file-invoice"
                                }, {
                                  default: _withCtx(() => [
                                    (!_ctx.mini)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                          key: 0,
                                          class: "v-list-item-title-active"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("menu.outstandingSupplier")), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.currentUser.showOutStandingUser && !_ctx.isAutonomousUser)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 2,
                                  "prepend-icon": "$fa-file-invoice",
                                  to: { name: 'outstandingUser', params: { mode: 'outstandingUser' } }
                                }, {
                                  default: _withCtx(() => [
                                    (!_ctx.mini)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                          key: 0,
                                          class: "v-list-item-title-active"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("menu.outstandingUser")), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : (_ctx.currentUser.showOutStandingClient && !_ctx.isAutonomousUser)
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 4,
                            to: { name: 'outstandingTPC', params: { mode: 'client' } }
                          }, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[40] || (_cache[40] = [
                                  _createTextVNode("$fa-file-invoice")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              (!_ctx.mini)
                                ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                    key: 0,
                                    class: "v-list-item-title-active"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("menu.outstandingClient")), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : (_ctx.currentUser.showOutStandingSupplier && !_ctx.isAutonomousUser)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 5,
                              to: { name: 'outstandingTPC', params: { mode: 'supplier' } }
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[41] || (_cache[41] = [
                                    _createTextVNode("$fa-file-invoice")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                (!_ctx.mini)
                                  ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                      key: 0,
                                      class: "v-list-item-title-active"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("menu.outstandingSupplier")), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : (
                            (_ctx.currentUser.showOutStandingExpenseReport ||
                                _ctx.currentUser.showOutStandingSalary) &&
                            !_ctx.isAutonomousUser
                        )
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 6,
                                to: { name: 'outstandingUser', params: { mode: 'outstandingUser' } }
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[42] || (_cache[42] = [
                                      _createTextVNode("$fa-file-invoice")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  (!_ctx.mini)
                                    ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                        key: 0,
                                        class: "v-list-item-title-active"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("menu.outstandingUser")), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                    (_ctx.enableBank)
                      ? (_openBlock(), _createBlock(_component_v_divider, { key: 7 }))
                      : _createCommentVNode("", true),
                    (_ctx.enableBank)
                      ? (_openBlock(), _createBlock(_component_v_list_group, {
                          key: 8,
                          modelValue: _ctx.isBankExpanded,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.isBankExpanded) = $event))
                        }, {
                          activator: _withCtx(({ isOpen, props }) => [
                            _createVNode(_component_v_list_item, {
                              "prepend-icon": "$oss-bank",
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.navigateToBank())),
                              class: "pr-0",
                              active: _ctx.currentRouteName === 'bank'
                            }, {
                              append: _withCtx(() => [
                                (
                                            _ctx.bankTransactionUsedTags &&
                                            _ctx.bankTransactionUsedTags.length
                                        )
                                  ? (_openBlock(), _createBlock(_component_v_btn_icon, _mergeProps({
                                      key: 0,
                                      onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.toggleExpandBank()), ["stop"])),
                                      class: "custom-expand-button"
                                    }, props, {
                                      color: "primary_foreground",
                                      icon: isOpen ? '$fa-chevron-up' : '$fa-chevron-down'
                                    }), null, 16, ["icon"]))
                                  : _createCommentVNode("", true)
                              ]),
                              default: _withCtx(() => [
                                (!_ctx.mini)
                                  ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                      key: 0,
                                      class: "v-list-item-title-active"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("menu.bank")), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["active"])
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bankTransactionUsedTags, (tag, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                  (tag.header)
                                    ? (_openBlock(), _createBlock(_component_v_list_subheader, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(tag.header), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: 1,
                                        inset: tag.header,
                                        density: "compact",
                                        to: { name: 'bank-tag', params: { tagId: tag.id } }
                                      }, {
                                        default: _withCtx(() => [
                                          (!_ctx.mini)
                                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                                key: 0,
                                                class: "v-list-item-title-active"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(tag.text ? `${tag.text} (${tag.count})` : tag.header), 1)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1032, ["inset", "to"]))
                                ], 64))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.userConfig?.document?.read)
                      ? (_openBlock(), _createBlock(_component_v_list_group, {
                          key: 9,
                          modelValue: _ctx.isDocumentExpanded,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.isDocumentExpanded) = $event))
                        }, {
                          activator: _withCtx(({ isOpen, props }) => [
                            _createVNode(_component_v_list_item, {
                              "prepend-icon": "$oss-archives",
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.navigateToDocuments())),
                              class: "pr-0",
                              active: _ctx.currentRouteName === 'documents'
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_btn_icon, _mergeProps({
                                  onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.toggleExpandDocument()), ["stop"])),
                                  class: "custom-expand-button"
                                }, props, {
                                  color: "primary_foreground",
                                  icon: isOpen ? '$fa-chevron-up' : '$fa-chevron-down'
                                }), null, 16, ["icon"])
                              ]),
                              default: _withCtx(() => [
                                (!_ctx.mini)
                                  ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                      key: 0,
                                      class: "v-list-item-title-active"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("menu.documents")), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["active"])
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              (_ctx.enableBank)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_v_list_subheader, null, {
                                      default: _withCtx(() => _cache[43] || (_cache[43] = [
                                        _createTextVNode("Filtres")
                                      ])),
                                      _: 1
                                    }),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usedFilters, (filter) => {
                                      return (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: filter.value,
                                        class: "ml-3",
                                        density: "compact",
                                        onClick: ($event: any) => (
                                            _ctx.navigateToDocumentsWithQuery(filter.type, filter.value)
                                        )
                                      }, {
                                        default: _withCtx(() => [
                                          (!_ctx.mini)
                                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                                key: 0,
                                                class: "v-list-item-title-active"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(filter.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    }), 128))
                                  ], 64))
                                : _createCommentVNode("", true),
                              (_ctx.documentUsedTags)
                                ? (_openBlock(), _createBlock(_component_TreeView, {
                                    key: 1,
                                    items: _ctx.documentUsedTags,
                                    branchClick: true
                                  }, {
                                    branch: _withCtx(({ name }) => [
                                      _createVNode(_component_v_list_subheader, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(name), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    leaf: _withCtx(({ name, id }) => [
                                      (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: id,
                                        density: "compact",
                                        to: { name: 'documents-tag', params: { tagId: id } }
                                      }, {
                                        default: _withCtx(() => [
                                          (!_ctx.mini)
                                            ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                                key: 0,
                                                class: "v-list-item-title-active"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(name), 1)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]))
                                    ]),
                                    _: 1
                                  }, 8, ["items"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    (
                            _ctx.userConfig?.salesInvoice.read &&
                            _ctx.selectedCompany.profile &&
                            _ctx.selectedCompany.profile.createSalesInvoice &&
                            _ctx.isAllowedToInvoice
                        )
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 10,
                          to: { name: 'invoices' }
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[44] || (_cache[44] = [
                                _createTextVNode("$oss-invoice")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            (!_ctx.mini)
                              ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                  key: 0,
                                  class: "v-list-item-title-active",
                                  "data-cy": "index-invoices"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$tm("menu.invoices")), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isAllowedToStock && _ctx.selectedCompany?.profile?.stock)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 11,
                          to: { name: 'stocks' }
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[45] || (_cache[45] = [
                                _createTextVNode("$oss-archives")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            (!_ctx.mini)
                              ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                  key: 0,
                                  class: "v-list-item-title-active"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$tm("menu.stocks")), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (
                            (!_ctx.selectedCompany.profile
                                ? true
                                : _ctx.selectedCompany.profile.createExpenseReport) &&
                            !_ctx.isAutonomousUser &&
                            _ctx.isAllowedToExpenseReport
                        )
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 12,
                          to: { name: 'expenseReports' }
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[46] || (_cache[46] = [
                                _createTextVNode("$oss-expense-report")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            (!_ctx.mini)
                              ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                  key: 0,
                                  class: "v-list-item-title-active"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("menu.expenseReports")), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.userConfig?.declaration.read && _ctx.isAllowedToTaxDeclaration)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 13,
                          to: { name: 'taxForms' }
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[47] || (_cache[47] = [
                                _createTextVNode("$fa-file-contract")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            (!_ctx.mini)
                              ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                  key: 0,
                                  class: "v-list-item-title-active"
                                }, {
                                  default: _withCtx(() => _cache[48] || (_cache[48] = [
                                    _createTextVNode(" Déclarations fiscales ")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.userConfig?.accounting.read)
                      ? (_openBlock(), _createBlock(_component_v_divider, {
                          key: 14,
                          class: _normalizeClass(_ctx.mini ? 'hide' : 'show')
                        }, null, 8, ["class"]))
                      : _createCommentVNode("", true),
                    (
                            _ctx.userConfig?.accounting.read && _ctx.isAllowedToAccounting && _ctx.isUserHasAccess
                        )
                      ? (_openBlock(), _createBlock(_component_v_list_group, {
                          key: 15,
                          "prepend-icon": "$oss-analysis"
                        }, {
                          activator: _withCtx(({ props }) => [
                            (!_ctx.mini)
                              ? (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({
                                  key: 0,
                                  class: "v-list-item-title-active"
                                }, props, { "prepend-icon": "$oss-analysis" }), {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, { class: "v-list-item-title-active-no-word" }, {
                                      default: _withCtx(() => _cache[49] || (_cache[49] = [
                                        _createTextVNode(" Comptabilité ")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1040))
                              : _createCommentVNode("", true)
                          ]),
                          default: _withCtx(() => [
                            (_ctx.userConfig?.accounting.write && !_ctx.isAutonomousUser)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 0,
                                  to: { name: 'accountingPeriodOpening' }
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[50] || (_cache[50] = [
                                        _createTextVNode("$oss-edit")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    (!_ctx.mini)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                          key: 0,
                                          class: "v-list-item-title-active"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("menu.accountingPeriodOpening")), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.userConfig?.accounting.log && !_ctx.isAutonomousUser)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 1,
                                  "model-value": 'accountingLog',
                                  to: { name: 'accountingLog' }
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[51] || (_cache[51] = [
                                        _createTextVNode("$oss-state")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    (!_ctx.mini)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                          key: 0,
                                          class: "v-list-item-title-active"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("menu.accountingLog")), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.userConfig?.accounting.accountingLine && !_ctx.isAutonomousUser)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 2,
                                  to: { name: 'accountingLines' }
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[52] || (_cache[52] = [
                                        _createTextVNode("$oss-state")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    (!_ctx.mini)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                          key: 0,
                                          class: "v-list-item-title-active"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("menu.accountingLines")), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.userConfig?.accounting.generalLedger)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 3,
                                  to: { name: 'generalLedger' }
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[53] || (_cache[53] = [
                                        _createTextVNode("$oss-general-ledger")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    (!_ctx.mini)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                          key: 0,
                                          class: "v-list-item-title-active"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.isAutonomousUser
                                        ? "Comptes en détail"
                                        : _ctx.$tm("menu.generalLedger")), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.userConfig?.capitalAsset?.read && _ctx.isAllowedToFixedAsset)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 4,
                                  to: {
                                name: 'fixedAssets',
                                params: {
                                    acKey: 'rIr4hG5NdQWyEnIXvhnYtmmm',
                                    companyId: _ctx.companyId,
                                    accountingPeriodId: _ctx.lastSelectedAccountingPeriodId || 'xx',
                                },
                            }
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[54] || (_cache[54] = [
                                        _createTextVNode("$oss-analysis")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    (!_ctx.mini)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                          key: 0,
                                          class: "v-list-item-title-active"
                                        }, {
                                          default: _withCtx(() => _cache[55] || (_cache[55] = [
                                            _createTextVNode(" Immobilisations ")
                                          ])),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : _createCommentVNode("", true),
                            (_ctx.userConfig?.accounting.auditReport && _ctx.isAllowedToAuditReport)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 5,
                                  to: { name: 'auditReport' }
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[56] || (_cache[56] = [
                                        _createTextVNode("$oss-folder")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    (!_ctx.mini)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                          key: 0,
                                          class: "v-list-item-title-active"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.isAutonomousUser ? "Fin d'exercice" : _ctx.$t("menu.auditReport")), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (
                                _ctx.userConfig?.accounting.dashboard && _ctx.isAllowedToDashboardAccounting
                            )
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 6,
                                  to: {
                                name: 'dashboardAccounting',
                            }
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[57] || (_cache[57] = [
                                        _createTextVNode("$fa-table")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    (!_ctx.mini)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                          key: 0,
                                          class: "v-list-item-title-active"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("menu.dashboardAccounting")), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.userConfig?.accounting.import)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 7,
                                  to: { name: 'accountingItems' }
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[58] || (_cache[58] = [
                                        _createTextVNode("$oss-import")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    (!_ctx.mini)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                          key: 0,
                                          class: "v-list-item-title-active"
                                        }, {
                                          default: _withCtx(() => _cache[59] || (_cache[59] = [
                                            _createTextVNode(" Imports ")
                                          ])),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.userConfig?.accounting.export)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 8,
                                  to: { name: 'exportAccounting' }
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[60] || (_cache[60] = [
                                        _createTextVNode("$oss-export")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    (!_ctx.mini)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                          key: 0,
                                          class: "v-list-item-title-active"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("menu.export")), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.userConfig?.accounting.export && !_ctx.isAllowedToAccounting)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 16,
                          to: { name: 'exportAccounting' }
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[61] || (_cache[61] = [
                                _createTextVNode("$oss-export")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            (!_ctx.mini)
                              ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                  key: 0,
                                  class: "v-list-item-title-active"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("menu.export")), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (
                            _ctx.userConfig?.accounting.read &&
                            (_ctx.userConfig?.accounting.audit ||
                                _ctx.userConfig?.accounting.openPoints ||
                                _ctx.userConfig?.accountingRule.read) &&
                            !_ctx.isAutonomousUser &&
                            _ctx.isAllowedToAccounting &&
                            _ctx.isUserHasAccess
                        )
                      ? (_openBlock(), _createBlock(_component_v_list_group, {
                          key: 17,
                          "model-value": false
                        }, {
                          activator: _withCtx(({ props }) => [
                            (!_ctx.mini)
                              ? (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({
                                  key: 0,
                                  class: "v-list-item-title-active"
                                }, props, { "prepend-icon": "$oss-analysis" }), {
                                  default: _withCtx(() => [
                                    (!_ctx.mini)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                          key: 0,
                                          class: "v-list-item-title-active",
                                          style: {"white-space":"normal","word-break":"break-word"}
                                        }, {
                                          default: _withCtx(() => _cache[62] || (_cache[62] = [
                                            _createTextVNode(" Gestion comptable ")
                                          ])),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1040))
                              : _createCommentVNode("", true)
                          ]),
                          default: _withCtx(() => [
                            (_ctx.userConfig?.accounting.read)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 0,
                                  to: { name: 'companyStatusBoard' }
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[63] || (_cache[63] = [
                                        _createTextVNode("$oss-analysis")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    (!_ctx.mini)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                          key: 0,
                                          class: "v-list-item-title-active"
                                        }, {
                                          default: _withCtx(() => _cache[64] || (_cache[64] = [
                                            _createTextVNode(" Etat du dossier ")
                                          ])),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.userConfig?.accounting.openPoints && _ctx.isAllowedToOpenPoint)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 1,
                                  to: { name: 'openPoints' }
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[65] || (_cache[65] = [
                                        _createTextVNode("$oss-analysis")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    (!_ctx.mini)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                          key: 0,
                                          class: "v-list-item-title-active"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("menu.openPoints")), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.userConfig?.accountingRule.read)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 2,
                                  to: { name: 'wording-analysis-client-side' }
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[66] || (_cache[66] = [
                                        _createTextVNode("$oss-analysis")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    (!_ctx.mini)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                          key: 0,
                                          class: "v-list-item-title-active"
                                        }, {
                                          default: _withCtx(() => _cache[67] || (_cache[67] = [
                                            _createTextVNode(" Analyse de libellé ")
                                          ])),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.userConfig?.accountingRule?.read)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 3,
                                  to: { name: 'document-rules-client-side' }
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[68] || (_cache[68] = [
                                        _createTextVNode("$oss-analysis")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    (!_ctx.mini)
                                      ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                          key: 0,
                                          class: "v-list-item-title-active"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("menu.documentRules")), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.userConfig?.company.read)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 18,
                          to: { name: 'companyEdition', params: { companyId: _ctx.selectedCompany.id } }
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[69] || (_cache[69] = [
                                _createTextVNode("$oss-folder")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            (!_ctx.mini)
                              ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                  key: 0,
                                  class: "v-list-item-title-active",
                                  "data-cy": "index-dossier"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.isAccountingUser ? _ctx.$t("menu.settingsAdmin") : _ctx.$t("menu.settings")), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true),
                    (_ctx.isUserInAccountingFirm)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 19,
                          to: { name: 'chat' }
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[70] || (_cache[70] = [
                                _createTextVNode("$oss-chat-filled")
                              ])),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            (!_ctx.mini)
                              ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                                  key: 0,
                                  class: "v-list-item-title-active"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.chatUser && _ctx.chatUser.unreadMessageCount)
                                      ? (_openBlock(), _createBlock(_component_v_badge, {
                                          key: 0,
                                          color: "error",
                                          content: _ctx.chatUser.unreadMessageCount || 0,
                                          dot: "",
                                          floating: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("menu.chat")), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["content"]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("menu.chat")), 1))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["rail"])
          ], 64)),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          (!_ctx.isOver30Days)
            ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.activateEditThirdCompanies)
        ? (_openBlock(), _createBlock(_component_ThirdPartyCompanies, {
            key: 2,
            modelValue: _ctx.activateEditThirdCompanies,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.activateEditThirdCompanies) = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.activateEditUsers)
        ? (_openBlock(), _createBlock(_component_UsersDialog, {
            key: 3,
            modelValue: _ctx.activateEditUsers,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.activateEditUsers) = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.activateTagManager)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 4,
            title: "Gérer vos étiquettes et journaux",
            modelValue: _ctx.activateTagManager,
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.activateTagManager) = $event)),
            width: "90vw"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_tag_manager)
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (!_ctx.hasAlreadyReceiveNotificationToday && _ctx.isOver15Days && _ctx.isFirstConnection)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 5,
            modelValue: _ctx.isFirstConnection,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.isFirstConnection) = $event)),
            width: "30vw",
            onClose: _cache[25] || (_cache[25] = ($event: any) => (_ctx.setNotificationDateForToday()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("notification.offer.over15DaysTitle")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("notification.offer.over15Days", { diff: _ctx.diffDate }, _ctx.diffDate)), 1),
                      _cache[72] || (_cache[72] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("notification.offer.contact")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : (!_ctx.hasAlreadyReceiveNotificationToday && _ctx.isOver30Days)
          ? (_openBlock(), _createBlock(_component_v_overlay, {
              key: 6,
              persistent: "",
              modelValue: _ctx.isOver30Days,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.isOver30Days) = $event)),
              height: "100vh",
              width: "100vw"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  width: "25vw",
                  location: "center center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("notification.offer.over30DaysTitle")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("notification.offer.over30Days")), 1),
                        _cache[73] || (_cache[73] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("notification.offer.contact")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
      (_ctx.isUserConnected)
        ? _withDirectives((_openBlock(), _createBlock(_component_ChatList, {
            key: 7,
            position: !_ctx.$vuetify.display.mobile ? '' : '10px',
            onChatSelected: _ctx.onChatSelected
          }, null, 8, ["position", "onChatSelected"])), [
            [_vShow, _ctx.openChatList]
          ])
        : _createCommentVNode("", true),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogCompanySelection,
        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.dialogCompanySelection) = $event)),
        "max-width": !_ctx.$vuetify.display.mobile ? '1000px' : undefined,
        "min-height": !_ctx.$vuetify.display.mobile ? '600px' : undefined,
        fullscreen: _ctx.$vuetify.display.mobile,
        "hide-overlay": _ctx.$vuetify.display.mobile,
        title: "Sélectionnez une société"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "w-100"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "pb-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field_filled, {
                    modelValue: _ctx.companySearch,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.companySearch) = $event)),
                    label: "Entrez le nom d'une société",
                    "data-cy": "index-companySearch",
                    class: "mb-2 w-100",
                    autofocus: "",
                    density: "compact"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_virtual_scroll, {
                    items: _ctx.companyList,
                    height: "600",
                    width: "1000",
                    "item-height": "48"
                  }, {
                    default: _withCtx(({ item: company }) => [
                      _createVNode(_component_v_list_item, {
                        onClick: ($event: any) => {
                                    _ctx.selectedCompany = company;
                                    _ctx.dialogCompanySelection = false;
                                    _ctx.companySearch = '';
                                },
                        "model-value": company.id,
                        border: "",
                        rounded: "xl",
                        class: "mb-2",
                        lines: "two"
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "grey lighten-1" }, {
                            default: _withCtx(() => _cache[74] || (_cache[74] = [
                              _createTextVNode("$fa-chevron-right")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, {
                            "data-cy": "index-companyName",
                            class: "v-list-item-title-active text-wrap"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(company.shortname || company.name), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Siret: " + _toDisplayString(company.siret), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "model-value"])
                    ]),
                    _: 1
                  }, 8, ["items"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "max-width", "min-height", "fullscreen", "hide-overlay"]),
      _createVNode(_component_v_snackbar, {
        modelValue: _ctx.apolloErrorSnackBar,
        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.apolloErrorSnackBar) = $event)),
        color: _ctx.apolloErrors.type,
        "multi-line": "",
        timeout: "5000"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            color: "white",
            variant: "plain",
            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.apolloErrorSnackBar = false))
          }, {
            default: _withCtx(() => _cache[75] || (_cache[75] = [
              _createTextVNode(" Close ")
            ])),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.apolloErrors.errorType) + " : " + _toDisplayString(_ctx.apolloErrors.request) + " ", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apolloErrors.messages, (msg, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(msg), 1))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "color"]),
      _createVNode(_component_SnackbarSurvey)
    ]),
    _: 1
  }))
}